// noinspection JSUnusedGlobalSymbols

export const environment = {
  production: true,
  apiUrl: 'https://api-test.zskarte.ch',
};
